<script>
	export let small = false;
	export let loading = false;
	export let disabled = false;

	let className = $$props.class ? " " + $$props.class : "";
</script>

<button class={className} class:loading class:small on:click {disabled} type="submit">
	{#if loading}<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{/if}
	<slot></slot>
</button>

<style>
	button {
		height: 50px;
		position: relative;
		background-color: var(--color-primary);
		border: 3px solid var(--color-primary);
		padding: 0.375rem 0.75rem;
		padding-top: 10px;
		padding-left: 15px;
		padding-right: 30px;
		color: var(--color-white);
		font-family: "Proxima Nova";
		font-size: 18px;
		font-weight: 600;
		border-radius: var(--border-radius-sm);
	}

	@media (max-width: 480px) {
		button {
			font-size: 14px;
		}
	}

	button.small {
		height: 34px;
		font-size: 16px;
		line-height: 1;
		padding-top: 0.2rem;
	}

	button::after {
		position: absolute;
		border-color: var(--color-white);
		border-style: solid;
		border-width: 3px 3px 0 0;
		content: "";
		display: inline-block;
		height: 12px;
		width: 12px;
		top: 16px;
		right: 13px;
		transform: rotate(45deg);
		transition: right 0.35s;
	}

	button.small::after {
		top: 8px;
	}

	button:hover {
		background-color: var(--color-white);
		border: 3px solid var(--color-primary);
		/*border-radius: 6px;*/
		color: var(--color-primary);
		transition: background-color 0.35s;
	}

	button:hover::after {
		border-color: var(--color-primary);
		border-style: solid;
		border-width: 3px 3px 0 0;
		content: "";
		display: inline-block;
		height: 12px;
		position: absolute;
		width: 12px;
		right: 10px;
		transform: rotate(45deg);
	}

	button:focus {
		border: 3px solid var(--color-white);
		box-shadow: 0 0 0 3px var(--color-primary);
		background-color: var(--color-primary);
		color: var(--color-white);
		outline: none;
		transition:
			box-shadow 0.35s,
			border 0.35s;
	}

	button:focus::after {
		border-color: var(--color-white);
	}

	@-webkit-keyframes spinner-loader {
		to {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	@keyframes spinner-loader {
		to {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	button:disabled,
	button.loading {
		pointer-events: none;
		opacity: 0.3;
	}

	button.loading span::before {
		position: relative;
		display: inline-block;
		top: -4px;
		width: 12px;
		height: 12px;
		vertical-align: text-bottom;
		border: 2px solid currentColor;
		border-right-color: transparent;
		border-radius: 50%;
		-webkit-animation: spinner-loader 0.75s linear infinite;
		animation: spinner-loader 0.75s linear infinite;
	}
</style>
